module.exports = __webpack_public_path__ + "media/images/items/anim-2-ac14b55e98709d64198c3b1abe9d65a0.webp";